import { C as CosmosIconChevronRight$1, d as defineCustomElement$1 } from './p-zEJ6k401.js';

const CosmosIconChevronRight = CosmosIconChevronRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronRight, defineCustomElement };
